import type { Locale, PersonalPromo, PromoType } from "@/types";
import { ApiError } from "./api";
import { formatUzs } from "./format";

type T = (path: string, vars?: Record<string, string | number>) => string;

export function describePromo(t: T, locale: Locale, promo: { type: PromoType; value: number; expiresAt?: string | null }): string {
  const main =
    promo.type === "percent"
      ? t("cart.promoDesc.percent", { v: promo.value })
      : promo.type === "fixed"
        ? t("cart.promoDesc.fixed", { v: formatUzs(promo.value, locale) })
        : t("cart.promoDesc.free_delivery");
  if (!promo.expiresAt) return main;
  const date = new Intl.DateTimeFormat(locale === "en" ? "en-GB" : "ru-RU", { day: "2-digit", month: "2-digit" }).format(new Date(promo.expiresAt));
  return `${main}, ${t("cart.promoDesc.until", { date })}`;
}

/** Turns a server promo error code into a friendly message in the current language. */
export function promoErrorText(t: T, locale: Locale, err: unknown): string {
  if (err instanceof ApiError && err.code?.startsWith("PROMO_")) {
    const amount = typeof err.details?.minOrderUzs === "number" ? formatUzs(err.details.minOrderUzs, locale) : "";
    const text = t(`cart.promoErrors.${err.code}`, { amount });
    if (!text.startsWith("cart.")) return text;
  }
  return err instanceof ApiError && err.status !== 0 ? err.message : t("common.error");
}

export type { PersonalPromo };
